/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cps: NonNullable<unknown> }} Event_Metrics_Cps_TitleInputs */

const en_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Characters Per Second`)
};

const fr_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Caracteres par seconde`)
};

const de_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Zeichen pro Sekunde`)
};

const it_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Caratteri al secondo`)
};

const ru_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} символов в секунду`)
};

const es_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Caracteres por segundo`)
};

const ja_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} 文字/秒`)
};

const hi_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} वर्ण प्रति सेकंड`)
};

const pt_pt2_event_metrics_cps_title = /** @type {(inputs: Event_Metrics_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cps} Caracteres por segundo`)
};

/**
* | output |
* | --- |
* | "{cps} Characters Per Second" |
*
* @param {Event_Metrics_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_cps_title = /** @type {((inputs: Event_Metrics_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_cps_title(inputs)
	if (locale === "de") return de_event_metrics_cps_title(inputs)
	if (locale === "it") return it_event_metrics_cps_title(inputs)
	if (locale === "ru") return ru_event_metrics_cps_title(inputs)
	if (locale === "es") return es_event_metrics_cps_title(inputs)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒字符数")
	if (locale === "ja") return ja_event_metrics_cps_title(inputs)
	if (locale === "hi") return hi_event_metrics_cps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_cps_title(inputs)
	return en_event_metrics_cps_title(inputs)
});